<template>
    <div class="mt-2 mb-5">
        <div class="search-block">
            <!-- SEARCH -->
            <div class="input-group">
                <input type="text" class="form-control" placeholder="Search for..." v-model="searchTerm">
                <span class="input-group-btn">
                    <button class="btn btn-success" type="button" v-on:click="search(searchTerm)">Search Boilerplates</button>
                </span>
            </div>

            <!-- TAGS -->
            <div class="row tags mt-3" id="tags">
                <ul class="col-sm-6 d-flex">
                    <span class="h5 mb-1">Frameworks</span>
                    <li class="input-group" v-for="(tag, index) in searchTags.frameworks">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" name="searchTagsSelected" v-bind:value="tag" v-model="searchTagsSelected" v-on:change="tagSearchTerm()">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description">{{ tag }}</span>
                        </label>
                    </li>
                    <span class="h5 mb-1 mt-3">CMS</span>
                    <li class="input-group" v-for="(tag, index) in searchTags.cms">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" name="searchTagsSelected" v-bind:value="tag" v-model="searchTagsSelected" v-on:change="tagSearchTerm()">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description">{{ tag }}</span>
                        </label>
                    </li>
                </ul>
                <ul class="col-sm-6 d-flex">
                    <span class="h5 mb-1">Testing</span>
                    <li class="input-group" v-for="(tag, index) in searchTags.testing">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" name="searchTagsSelected" v-bind:value="tag" v-model="searchTagsSelected" v-on:change="tagSearchTerm()">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description">{{ tag }}</span>
                        </label>
                    </li>
               
                    <span class="h5 mb-1 mt-3">Utilities</span>
                    <li class="input-group" v-for="(tag, index) in searchTags.utilities">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" name="searchTagsSelected" v-bind:value="tag" v-model="searchTagsSelected" v-on:change="tagSearchTerm()">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description">{{ tag }}</span>
                        </label>
                    </li>
                </ul>
            </div>

            <button class="btn btn-info mt-3" type="button" v-on:click="showTags()">{{ showTagsTxt }}</button>
        </div>


        <!-- SEARCH RESULTS -->
        <div class="mt-5 row justify-content-center" id="searchResults">
            <loader v-bind:isloading="isSearching"></loader>
            <div v-show="!isSearching">
                <template v-for="(boilerplate, index) in searchResults">
                    <boilerplateitem class="col-12" v-bind:itemdata="boilerplate" v-bind:type="'search'"></boilerplateitem>
                </template>
            </div>
            <h3 v-if="noResults && !isSearching">No boilerplates have been found for your search. Try something simpler.</h3>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import boilerplateitem from '@/components/boilerplate-item'
import loader from '@/components/utilities/loader'

const VueScrollTo = require('vue-scrollto');

export default {
  name: 'boilerplatesearch',
  components: { boilerplateitem, loader },
  props: ['itemdata'],
  data () {
    return {
        showTagsTxt: "Show more",
        searchTerm: null,
        searchTags: {
            'frameworks': [
                "Angular2+", "AngularJS", "React", "React Native", "Vue.js", "Ionic", "Cordova",            
                "Knockout.js", ".net", "Laravel", "CodeIgniter", "Symfony"
            ],
            'testing': [
                "PhantomJS", "Casper", "Mocha", "Jasmine", "Karma", "QUnit", "Selenium"
            ],
            'utilities': [
                "SCSS", "PostCSS", "Typescript", "Babel", "Gulp", "Grunt", "WebPack", "Docker"
            ],
            'cms': [
                "Wordpress", "Magento", "Drupal", "Joomla", "WebGUI"
            ]
        },
        searchTagsSelected: [],
        searchResults: [],

        noResults: null,
        isSearching: false
    
    }
  },
  computed: {
    searchTagsSelectedString: function () {
      return this.searchTagsSelected.toString().replace(/,/g, "+")
    }
  },
  methods: {
    scrollTo: function(element, duration){
        var options = {
            container: 'body',
            easing: 'ease-in',
            offset: -60,
            cancelable: true,
            onDone: function() {
            },
            onCancel: function() {
            }
        }
        VueScrollTo.scrollTo(element, duration, options)
    },
    search: function(term) {
        // save 'this' scope
        var self = this
        // get tags from selected tags string
        var tags = self.searchTagsSelectedString
    
        // set variables to seaching status
        self.isSearching = true
        self.searchResults = null

        // scroll to search results area
        this.scrollTo("#searchResults", 500);

        // build URL for GitHub API call
        var url = 'https://api.github.com/search/repositories?q=' + term + '+boilerplate&sort=stars&order=desc'
        // check for tags / manually input text
        if(tags.length && term)
            url = 'https://api.github.com/search/repositories?q=' + term + '+' + tags + '+boilerplate&sort=stars&order=desc'
        else if(tags.length)
            url = 'https://api.github.com/search/repositories?q=' + tags + '+boilerplate&sort=stars&order=desc'

        // call GitHub API
        axios.get(url)
            .then(function (response) {
                // set search results from API response
                self.searchResults = response.data.items

                // if no results found (used to show/hide no results text)          
                if(self.searchResults.length == 0)
                    self.noResults = true
                else
                    self.noResults = false
                
                // update isSearching boolean (to hide loader)
                setTimeout(function(){
                    self.isSearching = false
                }, 1000)
            })
            .catch(function (error) {
                console.log(error);
            });
    },

    tagSearchTerm(){
        var temp = this.searchTerm
        this.searchTerm = this.searchTagsSelected
    },
    showTags: function(){
        if(document.getElementById('tags').classList.contains('showtags')){
            document.getElementById('tags').classList.remove('showtags')
            this.showTagsTxt = "Show more";
        } else {
            document.getElementById('tags').classList.add('showtags')
            this.showTagsTxt = "Show less";
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $gutter:          1.25rem;
  $gutter-half:     $gutter / 2;

  h1, h2, h3, h4, h5, h6, 
  .h1, .h2, .h3, .h4, .h5, .h6 {
    margin-bottom: $gutter;
  }

    .input-group {
        .form-control,
        .btn {
            border: 0;
            height: $gutter * 3;
            padding: 0 $gutter * 1.2;
            font-size: 18px;
        }
    }

    .tags {
        padding: 0;
        flex-wrap: wrap;
        align-items: flex-start;
        height: 152px;
        overflow: hidden;
        position: relative;
        &.showtags {
            height: unset;
            &:after {
                display: none;
            }
        }
        &:after {
            background: -webkit-linear-gradient(top, rgba(23,43,77,0) 0%,rgba(23,43,77,1) 100%);
            background: linear-gradient(to bottom, rgba(23,43,77,0) 0%,rgba(23,43,77,1) 100%);
            content: '';
            display: block;
            position: absolute;
            top: auto; right: 0; bottom: 0; left: 0;
            width: 100%;
            height: 50%;
            pointer-events: none;
        }
        
        span {
            flex-basis: 100%;
        }
        ul {
            flex-wrap: wrap;
        }
        li {
            flex-basis: 50%;
            margin: 0;
            @media only screen and (max-width: 768px){
                flex-basis: 100%;
            }
        }
        .form-control,
        label {
            height: $gutter * 2;
            line-height: $gutter * 2;
        }
        label {
            padding-left: 2.1rem;
            margin: 0;
            width: 100%;
        }
    }

    .custom-control-indicator {
        width: 1.5rem;
        height: 1.5rem;
        top: 0.45rem;
        margin-right: 1.5rem;
    }


    @media only screen and (max-width: 575px){
        .input-group-btn {
            width: 100%;
            margin-top: $gutter-half;
            button {
                width: 100%;
            }
        }
        .input-group {
            flex-wrap: wrap;
            
            .form-control,
            .input-group-btn button {
                border-radius: 0.25rem !important;
            }
        }
    }
    @media only screen and (max-width: 515px){
        .tags {
            li {
                flex-basis: 50%;
            }
        }
    }

</style>




// WEBPACK FOOTER //
// boilerplate-search.vue?198b9e84